import { StandardEvents } from '@shopify/events';
let revision = 0;
function updateCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('.ch-cart span').forEach(el => { el.textContent = '(' + count + ')'; });
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const current = ++revision;
  event.promise?.then(({cart}) => {
    if (current === revision) updateCount(cart?.totalQuantity);
  }).catch(() => {});
});
window.addEventListener('pageshow', async event => {
  if (!event.persisted) return;
  const current = ++revision;
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {cache:'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    if (current === revision) updateCount(cart.item_count);
  } catch {}
});
